import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // Default is localStorage
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import { KioskDashboardReducer } from "./KioskDashboard.slice";
import { authReducer } from "./auth.slice";
import { usersReducer } from "./user.slice";
import { kioskLoginReducer } from "./KioskLogin.slice";
import { KioskNoticeReducer } from "./KioskNotice.slice";
import { MyInvitesReducer } from "./MyInvites.slice";
import { MyProfileSecurityQuestionsActionsReducer } from "./MyProfile.slice";
import { DocumentsReducer } from "./document.slice";
import { PostalMailReducer } from "./PostalMail.slice";
import { RequestsReducer } from "./Requests.slice";
import { PhotosReducer } from "./Photos.slice";
import { MyContactsReducer } from "./MyContacts.slice";
import { dropdownReducer } from "./dropdownOptions.slice";
import { inboxReducer } from "./inbox.slice";
import { E_CardReducer } from "./E_Card.slice";

export * from "./auth.slice";
export * from "./user.slice";
export * from "./KioskLogin.slice";
export * from "./dropdownOptions.slice";
export * from "./KioskDashboard.slice"
export * from "./E_Card.slice"


export const store = configureStore({
  reducer: {
    KioskDashboard: KioskDashboardReducer,
    users: usersReducer,
    auth: authReducer,
    kioskLogin: kioskLoginReducer,
    kioskNotice: KioskNoticeReducer,
    MyInvites: MyInvitesReducer,
    MyProfile: MyProfileSecurityQuestionsActionsReducer,
    Documents: DocumentsReducer,
    PostalMail: PostalMailReducer,
    Requests: RequestsReducer,
    Photos: PhotosReducer,
    MyContacts: MyContactsReducer,
    dropdownOptions: dropdownReducer,
    inbox: inboxReducer,
    E_Card: E_CardReducer

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['auth.connectionData'],
        ignoredActions: ['auth/updateconnectionData'],
      },
    }),


  devTools: process.env.REACT_APP_API_ENV !== "production", // Enables DevTools only in development mode
});

